import {Translate} from "../../../../hooks/translate.hook";
import {SmartColumn} from "../../../common/smart-table/smart-table.model";
import {
    PickupAuthorization
} from "../../../../models/accounts/customer-account/wholesale-account/wholesale.account.pickup-authorizations";
import {FieldType} from "../../../common/smart-table/smart-table.field-config";

export const columnsFactory = (t: Translate): SmartColumn<PickupAuthorization>[] => {
    return [
        {
            visibleName: "Number",
            dataIndex: "number",
            name: "number",
            type: FieldType.STRING,
        },
        {
            visibleName: "Issued By",
            dataIndex: "issuedBy",
            name: "issuedBy",
            type: FieldType.STRING,
        },
        {
            visibleName: "Authorized Person",
            dataIndex: "authorizedPerson",
            name: "authorizedPerson",
            type: FieldType.STRING,
        },
        {
            visibleName: "Default",
            dataIndex: "default",
            name: "default",
            type: FieldType.BOOLEAN,
        }
    ]
}